import { render, staticRenderFns } from "./EstablishmentViewContactsAddContactModal.vue?vue&type=template&id=0b958da4"
import script from "./EstablishmentViewContactsAddContactModal.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewContactsAddContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports